import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import ProductCard from "../components/ProductCard";
import { polos } from "../mock";
import { ArrowRight } from "lucide-react";

export default function Polos() {
  return (
    <PageShell kicker="Polos" title="Professional polos for your team" subtitle="Send us your logo and we'll put it on every shirt — clean, consistent, and the same on the hundredth polo as it was on the first.">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {polos.map((p) => <ProductCard key={p.id} product={p} showPriceLabel />)}
      </section>
      <section className="bg-[color:var(--dms-navy)] py-20">
        <div className="max-w-3xl mx-auto text-center px-5">
          <h2 className="font-serif text-3xl md:text-4xl text-white">Need 12, 30, 50+ polos?</h2>
          <p className="mt-4 text-white/75">Group pricing available. Send us the details and we'll send back a custom quote.</p>
          <div className="mt-8"><Link to="/group-orders" className="btn-peach">Request a group quote <ArrowRight className="w-4 h-4" /></Link></div>
        </div>
      </section>
    </PageShell>
  );
}
